module.exports = __webpack_public_path__ + "media/images/my_apps/feature_icons/cw_my_apps_plant-110e888710b9bb8b68642791c771b0e7.svg";